export enum KeyCodes {
  LEFTARROW = 37,
  RIGHTARROW = 39
}
